// ============================================
// src/components/payments/PaymentSummary.js
// Summary statistics cards
// ============================================

import React from 'react';

function PaymentSummary({ stats, loading }) {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        Loading statistics...
      </div>
    );
  }

  const collectionPercentage = stats.totalAmount > 0 
    ? Math.round((stats.collectedAmount / stats.totalAmount) * 100) 
    : 0;

  return (
    <div style={{ 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
      gap: '15px',
      marginBottom: '20px'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #667eea, #764ba2)',
        color: 'white',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}>
        <div style={{ fontSize: '14px', opacity: 0.9 }}>Total Residents</div>
        <div style={{ fontSize: '28px', fontWeight: 'bold', marginTop: '5px' }}>
          {stats.totalResidents}
        </div>
        <div style={{ fontSize: '12px', marginTop: '5px', opacity: 0.8 }}>
          Active flats
        </div>
      </div>

      <div style={{
        background: 'linear-gradient(135deg, #28a745, #20c997)',
        color: 'white',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}>
        <div style={{ fontSize: '14px', opacity: 0.9 }}>Paid</div>
        <div style={{ fontSize: '28px', fontWeight: 'bold', marginTop: '5px' }}>
          {stats.totalPaid}
        </div>
        <div style={{ fontSize: '12px', marginTop: '5px', opacity: 0.8 }}>
          ₹{stats.collectedAmount} collected
        </div>
      </div>

      <div style={{
        background: 'linear-gradient(135deg, #ffc107, #ff9800)',
        color: 'white',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}>
        <div style={{ fontSize: '14px', opacity: 0.9 }}>Pending</div>
        <div style={{ fontSize: '28px', fontWeight: 'bold', marginTop: '5px' }}>
          {stats.totalPending}
        </div>
        <div style={{ fontSize: '12px', marginTop: '5px', opacity: 0.8 }}>
          ₹{stats.totalAmount - stats.collectedAmount} remaining
        </div>
      </div>

      <div style={{
        background: 'linear-gradient(135deg, #17a2b8, #138496)',
        color: 'white',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}>
        <div style={{ fontSize: '14px', opacity: 0.9 }}>Collection Rate</div>
        <div style={{ fontSize: '28px', fontWeight: 'bold', marginTop: '5px' }}>
          {collectionPercentage}%
        </div>
        <div style={{ fontSize: '12px', marginTop: '5px', opacity: 0.8 }}>
          Target: ₹{stats.totalAmount}
        </div>
      </div>
    </div>
  );
}

export default PaymentSummary;